import React, { useEffect, useState } from "react";
import PageLoader from "../../common/pageLoader";
import ManageUsersComponent from "./manageUsers";
import { manageUsers } from "../../../redux/slice/manageUsersSlice";
import { connect } from "react-redux";
import { Button } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { userRoleSwitch } from "../../../redux/slice/userRoleSwitchSlice";
import Notify from "../../common/notify/notify";
import { userDelete } from "../../../redux/slice/userDeleteSlice";
import { userRoleDelete } from "../../../redux/slice/userRoleDeleteSlice";
import { useParams } from "react-router-dom";
import { societyWingList } from "../../../redux/slice/societyWingListSlice";
import { Cookies } from "react-cookie";

const ManageUsers = (props) => {
  const { id } = useParams();

  const {
    callmanageUsersData,
    manageUsersData,
    calluserRoleSwitchData,
    calluserDeleteData,
    calluserRoleDeleteData,
    callsocietyWingListData,
    societyWingListData,
  } = props;
  const loading = manageUsersData.isLoading;
  const [rangeValue, setRangeValue] = useState([null, null]);
  const [selectedRoles, setSelectedRoles] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmRoleModal, setConfirmRoleModal] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [selectedWing, setSelectedWing] = useState(null);

  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [selectedUserForInfo, setSelectedUserForInfo] = useState(null);

  const cookies = new Cookies();
  const societyId = cookies.get("societyId");

  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({
    role: null,
    status: null,
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    const societyIdToFetch = id || societyId;
    if (societyIdToFetch) {
      callsocietyWingListData(societyIdToFetch);
    }
  }, [id, societyId, callsocietyWingListData]);

  const wingList = societyWingListData?.societyWingListData?.data?.data || [];

  useEffect(() => {
    const societyIdToFetch = id || societyId;
    if (societyIdToFetch) {
      callmanageUsersData({
        id: societyIdToFetch,
        filters,
      });
    }
  }, [id, societyId, filters, callmanageUsersData]);

  const handleClearFilters = () => {
    setFilters({
      role: null,
      status: null,
      startDate: null,
      endDate: null,
    });
    setRangeValue([null, null]);
    setSearchText("");
    setSelectedWing(null);
  };

  const userDataList = manageUsersData?.manageUsersData?.data?.data;

  const handleRoleChange = (value) => {
    setFilters((prev) => ({ ...prev, role: value }));
  };

  const handleStatusChange = (value) => {
    setFilters((prev) => ({ ...prev, status: value }));
  };

  const handleDateChange = (dates, dateStrings) => {
    setFilters({
      ...filters,
      startDate: dateStrings[0],
      endDate: dateStrings[1],
    });
    setRangeValue(dates);
  };

  const handleWingFilterChange = (value) => {
    setSelectedWing(value);
  };

  function formatPhoneNumber(phoneNumber) {
    if (typeof phoneNumber === "string") {
      return phoneNumber
        .replace(/^\+?(\d{2})/, "")
        .replace(/(\d{5})(\d{5})/, "$1 $2");
    } else if (typeof phoneNumber === "number") {
      return String(phoneNumber)
        .replace(/^\+?(\d{2})/, "")
        .replace(/(\d{5})(\d{5})/, "$1 $2");
    }
    return "N/a";
  }

  const handleShowInfo = (userId) => {
    const user = userDataList.find((u) => u._id === userId);
    if (user) {
      setSelectedUserForInfo(user);
      setInfoModalVisible(true);
    } else {
      Notify("error", "User details could not be found. Please check your information and try again.", "");
    }
  };

  const handleDeleteRole = async (roleData) => {
    const societyIdToUse = id || societyId;
    if (!societyIdToUse) {
      Notify("error", "Cannot delete role because the society ID is not available. Kindly check and retry.", "");
      return;
    }

    const payload = {
      userId: roleData.userId,
      flatId: roleData.flatId,
      wingId: roleData.wingId,
      societyId: societyIdToUse,
      role: roleData.roles,
    };

    try {
      const result = await calluserRoleDeleteData(payload);

      if (result.type === "userRoleDelete/fulfilled") {
        Notify("success", "The role has been deleted successfully!", "");

        const usersResponse = await callmanageUsersData({
          id: societyIdToUse,
          filters,
        });
        const updatedUsers = usersResponse.payload?.data?.data;

        if (updatedUsers) {
          const updatedSelectedUser = updatedUsers.find(
            (u) => u._id === payload.userId
          );
          if (updatedSelectedUser) {
            setSelectedUserForInfo(updatedSelectedUser);
          } else {
            setInfoModalVisible(false);
          }
        } else {
          setInfoModalVisible(false);
        }
      } else {
        const errorMessage =
          result.payload?.message ||
          result.error?.message ||
          "Failed to delete role.";
        Notify("error", "Oops! Something went wrong. Please try again later.", "");
      }
    } catch (error) {
      Notify("error", "Oops! Something went wrong. Please try again later.", "");
    }
  };

  const user_table_columns = [
    {
      title: "Sr. No.",
      dataIndex: "key",
      key: "key",
      render: (text) => <span>{text.toString().padStart(2, "0")}</span>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name) =>
        name
          ? name
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")
          : "",
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Join Date",
      dataIndex: "joinDate",
      key: "joinDate",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => {
        if (!role) return "";
        return role
          .replace(/_/g, " ")
          .split(" ")
          .map((word) =>
            word
              .split("/")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
              .join("/")
          )
          .join(" ");
      },
    },
    {
      title: "Wing",
      dataIndex: "wings",
      key: "wings",
      render: (priority) =>
        priority
          ? priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase()
          : "",
    },
    {
      title: "Flat Number",
      dataIndex: "flat_no",
      key: "flat_no",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => {
        return (
          <div className="edit-delete">
            <Button
              icon={<EditOutlined />}
              style={{ marginRight: 8 }}
              onClick={() => {
                setSelectedUser(record);
                handleChangeRole();
              }}
              disabled={
                !record.flat_no ||
                record.flat_no === "N/a" ||
                ["president", "owner , president"].includes(record.role)
              }
            />

            <Button
              icon={<DeleteOutlined />}
              style={{ marginRight: 8 }}
              onClick={() => {
                setSelectedUser(record);
                handleuserDelete();
              }}
              disabled={["president", "owner , president"].includes(
                record.role
              )}
            />

            <Button
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 8 }}
              onClick={() => handleShowInfo(record.id)}
              disabled={["guard", "wing_guard"].includes(record.role)}
            />
          </div>
        );
      },
    },
  ];

  const filteredData = userDataList
    ?.filter((item) => {
      const name = (item?.name || "").toLowerCase();
      const phone = (item?.phone_number || "").toString().toLowerCase();
      const search = searchText.toLowerCase();
      const matchesSearch = name.includes(search) || phone.includes(search);
      const matchesWing = selectedWing
        ? item?.assignments?.some((a) => a.wing_id === selectedWing)
        : true;
      return matchesSearch && matchesWing;
    })
    ?.map((item, index) => ({
      key: index + 1,
      id: item?._id,
      name: item?.name || "N/a",
      user_id: item?.user_id || "N/a",
      phone_number: item?.phone_number || "N/a",
      joinDate: new Date(item.createdAt)?.toLocaleDateString("en-GB") || "N/a",
      wings: item?.assignments[0]?.wing || "N/a",
      wing_id: item?.assignments[0]?.wing_id || "N/a",
      flat_no: item?.assignments[0]?.flat || "N/a",
      flat_id: item?.assignments[0]?.flat_id || "N/a",
      role: item?.assignments[0]?.roles.join(" , ") || "N/a",
      roles: item?.assignments || "N/a",
    }));

  useEffect(() => {
    if (selectedUser) {
      setSelectedRoles(selectedUser.role ? selectedUser.role.split("/") : []);
    }
  }, [selectedUser]);

  const handleConfirmRole = async () => {
    if (
      !selectedUser?.user_id ||
      !selectedUser.wing_id ||
      !selectedUser.flat_id
    ) {
      Notify(
        "error",
        "User details are incomplete. Please review the information and try again.",
        ""
      );
      return;
    }

    try {
      const result = await calluserRoleSwitchData({
        user_id: selectedUser.user_id,
        society: id,
        wing: selectedUser.wing_id,
        flat: selectedUser.flat_id,
        role: selectedRoles,
      });

      if (result.type === "userRoleSwitch/fulfilled") {
        Notify("success", "The role has been updated successfully!", "");
        setConfirmRoleModal(false);
        await callmanageUsersData({ id, filters });
      } else if (result.type === "userRoleSwitch/rejected") {
        Notify("error", "Oops! Something went wrong. Please try again later.", "");
      }
    } catch (error) {
      Notify("error", "Oops! Something went wrong. Please try again later.", "");
    }
  };

  const handleChangeRole = () => {
    setConfirmRoleModal(true);
  };

  const handleuserDelete = () => {
    setConfirmDeleteModal(true);
  };

  const handleConfirmDelete = async (userId) => {
    if (!userId || !id) {
      Notify("error", "The ID is missing. Please ensure all information is complete and try again.", "");
      return;
    }
    try {
      const result = await calluserDeleteData({ userId, id });

      if (result.type === "userDelete/fulfilled") {
        Notify("success", "The user has been deleted successfully!", "");
        setConfirmDeleteModal(false);
        await callmanageUsersData({ id, filters });
      } else if (result.type === "userDelete/rejected") {
        Notify("error", "Oops! Something went wrong. Please try again later." || "Failed to delete user.", "");
      }
    } catch (error) {
      Notify("error", "Oops! Something went wrong. Please try again later.", "");
    }
  };

  return (
    <>
      {loading && <PageLoader />}
      <ManageUsersComponent
        callmanageUsersData={callmanageUsersData}
        manageUsersData={manageUsersData}
        user_table_columns={user_table_columns}
        userDataList={userDataList}
        handleRoleChange={handleRoleChange}
        handleStatusChange={handleStatusChange}
        handleDateChange={handleDateChange}
        handleClearFilters={handleClearFilters}
        filters={filters}
        rangeValue={rangeValue}
        selectedRoles={selectedRoles}
        setSelectedRoles={setSelectedRoles}
        handleChangeRole={handleChangeRole}
        handleuserDelete={handleuserDelete}
        confirmRoleModal={confirmRoleModal}
        setConfirmRoleModal={setConfirmRoleModal}
        confirmDeleteModal={confirmDeleteModal}
        setConfirmDeleteModal={setConfirmDeleteModal}
        selectedUser={selectedUser}
        handleConfirmRole={handleConfirmRole}
        handleConfirmDelete={handleConfirmDelete}
        filteredData={filteredData}
        searchText={searchText}
        setSearchText={setSearchText}
        formatPhoneNumber={formatPhoneNumber}
        selectedWing={selectedWing}
        setSelectedWing={setSelectedWing}
        handleWingFilterChange={handleWingFilterChange}
        wingList={wingList}
        infoModalVisible={infoModalVisible}
        setInfoModalVisible={setInfoModalVisible}
        selectedUserForInfo={selectedUserForInfo}
        handleDeleteRole={handleDeleteRole}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  manageUsersData: state.manageUsersData,
  userDeleteData: state.userDeleteData,
  userRoleDeleteData: state.userRoleDeleteData,
  societyWingListData: state.societyWingListData,
});

const mapDispatchToProps = (dispatch) => ({
  callsocietyWingListData: (data) => dispatch(societyWingList(data)),
  callmanageUsersData: (data) => dispatch(manageUsers(data)),
  calluserRoleSwitchData: (data) => dispatch(userRoleSwitch(data)),
  calluserDeleteData: (data) => dispatch(userDelete(data)),
  calluserRoleDeleteData: (data) => dispatch(userRoleDelete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
